
import { ApiError } from '@ms/utilities-error/lib/ApiError';
import { CustomError } from '@ms/utilities-error/lib/CustomError';
import { IQosEndSchema, ResultTypeEnum } from '../events/Qos.event';

/**
 * @public
 */
export function getQosEndSchemaFromError(error: Error | undefined): IQosEndSchema {
  return {
    resultType: error ?
      ResultTypeEnum.Failure :
      ResultTypeEnum.Success,
    error: error && (error.message || error.name),
    resultCode: error && error.name || 'Unknown',
    ...(error instanceof ApiError ? {
      resultCode: getResultCode(error),
      resultType: error.isExpected ?
        ResultTypeEnum.ExpectedFailure :
        ResultTypeEnum.Failure
    } : {}),
    extraData: {
      stack: error && error.stack,
      ...(error instanceof CustomError ? {
        ...(error.innerError ? {
          innerError: getQosEndSchemaFromError(error.innerError)
        } : {})
      } : {}),
      ...(error instanceof ApiError ? {
        correlationId: error.correlationId,
        ...(error.extraData ? {
          ...error.extraData
        } : {})
      } : {})
    }
  };
}

function getResultCode(apiError: ApiError): string {
  const parts: string[] = [];

  if (apiError.extraData && typeof apiError.extraData.status !== 'undefined') {
    parts.push(`[${apiError.extraData.status}]`);
  }

  if (apiError.code) {
    parts.push(`${apiError.code}`);
  }

  return parts.join(' ');
}
